<template class="fondo">
  <div class="loader" v-if="this.isLoading">
    <img class="rounded mx-auto d-block" src="@/assets/loading.gif" />
  </div>
  <div class="contenedor fondo text-center">
    <div class="d-flex contimg">
      <img src="@/assets/img2.png" class="imagens">
    </div>
    <div class="d-flex contimg2">
      <img src="@/assets/img1.png" class="imagens2">
      <div class="texto-derecha texto-derecha-mobile">
        <label>SI ERES SOCIO ENJOY CLUB</label>
        <div class="curadradoRojo">
          <label>JUEGA Y GANA UNO DE LOS</label><br>
          <label class="masFont">2.000</label><br>
          <label>VIAJES EN CRUCEROS</label><br>
        </div>
        <label>¡TÚ ELIGES EL DESTINO!</label>
      </div>
    </div>
      
    <div class="texto-center">
      <span class="texto-bold textMobile">{{nombre}}</span>
    </div>

    <div class="texto-center">
      <span class="texto-rojo textMobile">TU POSICÍON EN EL RANKING ES:</span>
    </div>

    <div class="texto-center">
      <span class="texto-bold rank">{{data.ranking}}</span>
    </div>

    <div class="texto-center">
      <span class="texto-bold" >(INFORMACÍON ACTUALIZADA AL {{data.fecha}}.)</span>
    </div>
  
    <div class="texto-center" >
      <img src="@/assets/img10.png" class="imagens2 imgMobile2">  
    </div>

    <div class="texto-center">
      <span class="texto-bold" >RECUERDA QUE TIENES HASTA EL 01 DE DICIEMBRE DE 2023 PARA ACUMULAR PUNTOS.</span>
    </div>
<div class="texto-center texto-rojo textMobile" style="border-radius: 30px; padding: 20px;">
  AL FINALIZAR EL PERÍODO DE ACUMULACIÓN, LOS PRIMEROS 2000 CLIENTES DEL RANKING GENERARÁN UN CRUCERO PARA DOS PERSONAS*.
</div>

    <div class="texto-center">
      <p class="texto-white">Revisa las <a href="https://www.enjoy.cl/cruceros/bases.pdf" target="_blank" style="color: white;">bases y condiciones aquí</a>.</p>
    </div>
  </div>

<div class="row justify-content-center">
    <div class="col-md-12">
      <img src="@/assets/img3.png" alt="Imagen 1" style="width: 100%;">
    </div>
  </div>


  <!--<div v-if="true" class="footer heightFooter">
    <img src="@/assets/logoenjoy.png" alt="">
  </div>-->
</template>

<style>
/* Animación para el div con clase "header" */
.header-animation {
  animation: fadeInAnimation 1s ease;
}

@keyframes fadeInAnimation {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Animación para el div con clase "opcion" */
.opcion-animation {
  animation: slideInLeftAnimation 1s ease;
}

@keyframes slideInLeftAnimation {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0);
  }
}
</style>
<script>
export default {
    computed:{
      data(){
        return this.$store.state.data.data;
      },
      nombre(){
        return this.$store.state.nombre
      },
    },
   created(){
      window.scrollTo(0,0);
    },
    methods:{
        formatNumberWithThousandsSeparator(number) {
        // Convierte el número a una cadena y le agrega el separador de miles
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      formatDate(dateString) {
      if (!dateString) return "";
      const dateParts = dateString.split("-");
      if (dateParts.length !== 3) return dateString;

      const day = dateParts[2];
      const month = dateParts[1];
      const year = dateParts[0];

      return `${day}-${month}-${year}`;
    },
    }
}
</script>


<style>


/* Estilos para pantallas más grandes (por ejemplo, PCs) */
@media (min-width: 768px) {
  .contimg {
  display: flex;
  width: 100%; /* El div ocupa el 100% del ancho de la pantalla */
  align-items: left;
}


.imagens {
  width: 20%; /* La imagen ocupa el 20% del ancho del div */
  margin-top: 2%; /* Margen superior en dispositivos móviles */
  margin-left: 10%;
}

.contimg2 {
  display: flex;
  width: 100%;
  position: relative;
  margin-top: -10%;

}

.imagens2 {
  width: 100%;
}

.curadradoRojo{
  background-color: #d7332a; /* Fondo rojo */
  padding: 10px;

}
.texto-derecha {
  position: absolute;
  top: 50%;
  right: 5%;
  color: white; /* Texto en blanco */
  transform: translateY(-50%);
  text-align: center;
  font-size: 40px; /* Establece el tamaño de fuente solo para el segundo label */
  padding: 10px;
}

.texto-derecha label {
  font-weight: bold; /* Hace que todos los labels sean negrita */
  color: white; /* Texto en blanco */
  margin: auto;
  padding: auto;
}


.texto-derecha br {
  margin: 0%;
  padding: 0%;

}
.masFont {
  font-size: 150px; /* Establece el tamaño de fuente solo para el segundo label */
  color: white; /* Texto en blanco */
  margin: auto;
  padding: auto;

}

.texto-center {
  text-align: center;
  margin-left: 10%;
  margin-right: 10%;
  margin-top: 1%;
}

.texto-white {
  color: #FFFFFF;
  font-family: 'Gotham', sans-serif;
  font-weight: lighter; /* Texto ligero */
  font-size: 18px;
}

.texto-bold {
  font-weight: bold;
  font-size: 24px;
  color: #FFFFFF;

}

.texto-rojo {
  background-color: #d7332a;
  color: white; /* Color de texto blanco */
  padding: 5px 10px; /* Espaciado interno */
  border-radius: 4px; /* Bordes redondeados */
}

.textMobile {
  font-size: 26px !important;
}

.rank{
    font-size: 250px !important;

  }

  .imgMobile2{
    width: 50% !important;
  }

}

/* Estilos para pantallas más pequeñas (por ejemplo, dispositivos móviles) */
@media (max-width: 767px) {

  .texto-derecha-mobile {
    font-size: 8px !important;
  }

  .rank{
    font-size: 150px !important;

  }
  .imgMobile2{
    width: 100% !important;
  }

  .imgMobile{
    width: 100% !important;
  }
  .textMobile {
    font-size: 22px !important;
}


  .contimg {
  width: 100%; /* El div ocupa el 100% del ancho de la pantalla */
  align-items: center;
  text-align: center;
}
  .imagens {
    width: 80%; /* Porcentaje de ancho para dispositivos móviles */

  }
  .contimg2 {
    display: flex;
    width: 100%;
    position: relative;
  }

  .imagens2 {
    width: 100%;
  }

  .curadradoRojo {
    background-color: #d7332a;
    padding: 10px;
  }

  .texto-derecha {
    position: absolute;
    top: 50%;
    right: 5%;
    color: white;
    transform: translateY(-50%);
    text-align: center;
    font-size: 15px;
    padding: 10px;
  }

  .texto-derecha label {
    font-weight: bold;
    color: white;
    margin: auto;
    padding: auto;
  }

  .texto-derecha br {
    margin: 0;
    padding: 0;
  }

  .masFont {
    font-size: 20px;
    color: white;
    margin: auto;
    padding: auto;
  }

  .texto-center {
    text-align: center;
    margin-left: 10%;
    margin-right: 10%;
    margin-top: 1%;
  }

  .texto-white {
    color: #FFFFFF;
    font-family: 'Gotham', sans-serif;
    font-weight: lighter;
    font-size: 18px;
  }

  .texto-bold {
    font-weight: bold;
    font-size: 24px;
    color: #FFFFFF;
  }

  .texto-rojo {
    background-color: #d7332a;
    color: white;
    padding: 5px 10px;
    border-radius: 4px;
  }
}
</style>